// extracted by mini-css-extract-plugin
module.exports = {"info-row":"InfoRow_info-row__3EzCA","info-row__title":"InfoRow_info-row__title__3ONjR","info-row__content":"InfoRow_info-row__content__itznv"};